import { render, staticRenderFns } from "./msgReview.vue?vue&type=template&id=0a3a6d61&scoped=true&"
import script from "./msgReview.vue?vue&type=script&lang=js&"
export * from "./msgReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a6d61",
  null
  
)

export default component.exports